//L18n Vuetify
import { createI18n } from "vue-i18n";
import { messages } from "@/plugins/l18i/messages";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
const i18n = createI18n({
    legacy: false,
    locale: "de",
    fallbackLocale: "gb",
    messages: messages,
});

export {i18n};